function handleWishlistSizeButtons($this) {
   let $wrapper = $this.closest('.atc-with-remove-wishlist-btn');
   if(window.matchMedia('(max-width: 750px)').matches){
      $wrapper?.classList.toggle('show-wishlist-sizes');
      $wrapper.querySelectorAll('modal-opener').forEach(el => el.style.display = 'none');

       document.addEventListener('click', (e) => {
    if (!$wrapper.contains(e.target)) {
     $wrapper.classList.remove('show-wishlist-sizes');
    }
  });
   }
  
}
// function addVariantToCart($event, $this) {
//       $event.preventDefault();
//         $this.setAttribute('aria-disabled', true);
//           $this.classList.add('loading');

//        let $formWrapper = $this.closest('product-form-inline-buttons');
//         let $form = $formWrapper.querySelector('form');
//          $form.querySelector('[name=id]').value = parseInt($this.dataset.variantId, 10);

//           $formWrapper.submitForm($this);
//       }
if (!customElements.get('product-form-inline-buttons')) {
  customElements.define('product-form-inline-buttons', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if(this.form?.querySelector('[name=id]')){
         this.form.querySelector('[name=id]').disabled = false;
      }
     
      this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      let $this = this;

  
      this.querySelectorAll("[data-variant-item]").forEach(variantItem => {
        variantItem.addEventListener('click', function(e){

          variantItem.setAttribute('aria-disabled', true);
          variantItem.classList.add('loading');

          $this.form.querySelector('[name=id]').value = parseInt(e.target.dataset.variantId, 10);

         $this.submitForm(variantItem);
      });
      });
      if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {

      evt.preventDefault();

      
      console.log("submitForm custom js", evt);
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

     this.submitForm(this.submitButton);
    }
    submitForm(currentElement){
       this.handleErrorMessage();

      if(typeof currentElement !== "undefined" && currentElement){
        currentElement.setAttribute('aria-disabled', true);
        currentElement.classList.add('loading');
        currentElement.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              if(typeof currentElement !== "undefined" && currentElement){
              currentElement.setAttribute('aria-disabled', true);
              currentElement.querySelector('span')?.classList.add('hidden');
              }
              soldOutMessage?.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

          if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
          });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if(typeof currentElement !== "undefined" && currentElement){
          currentElement.classList.remove('loading');
          }
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) {

            if(typeof currentElement !== "undefined" && currentElement){
            currentElement.removeAttribute('aria-disabled');
            }
          }
          if(typeof currentElement !== "undefined" && currentElement){
          currentElement.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
        });
    }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
  });
}
/** Wishlist **/
var WishlistProducts = class extends HTMLElement {
  constructor() {
    super();
  }
   connectedCallback() {

    // console.log("connectedCallback")
     this.loadWishlistProducts();
    
  }
  async loadWishlistProducts() {
    
     const items = new Set(JSON.parse(localStorage.getItem("theme:wishlist-products") || "[]"));
     const _searchQueryString =   Array.from(items.values(), (item) => `id:${item}`).join(" OR ");
      const wishlist_count = Array.from(items.values()).length;
    if(document.getElementById('wishlist-count')){
      document.getElementById('wishlist-count').innerHTML = wishlist_count;
    }
      
      const section = this.closest(".shopify-section");
         let  sectoinElement = section.classList.contains("shopify-section") ? section : section.closest(".shopify-section");
      sectoinElement =  sectoinElement.id.replace("shopify-section-", "");
      const url = `${Shopify.routes.root}search?type=product&q=${_searchQueryString}&section_id=${sectoinElement}`, response = await fetch(url, { priority: "low" });
  const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), wishlistProductsElement = tempDiv.querySelector("wishlist-products");
 
    if (wishlistProductsElement.childElementCount > 0) {
  this.replaceChildren(...document.importNode(wishlistProductsElement, true).childNodes);
handleWishlist();
setTimeout(() => {
  document.querySelectorAll('#CartDrawer modal-opener').forEach(el => {
    el.style.cssText = 'visibility:hidden!important;position:absolute!important;pointer-events:none!important;';
  });
}, 500);
    //sizeButtonsEventBindings();
  } else {
    section.remove();
  }
  }
};

if (!window.customElements.get("wishlist-products")) {
  window.customElements.define("wishlist-products", WishlistProducts);
}
window.addToWishlist = (productId, wishlistElement) => {
	let wishlistProducts = localStorage.getItem('theme:wishlist-products') || '[]';
     productId = parseInt(productId, 10);
    wishlistProducts = JSON.parse(wishlistProducts);
	
	if(wishlistElement.classList.contains('added-wishlist')) {
		wishlistElement.classList.remove('added-wishlist');
        let productIndexToRemove = wishlistProducts.indexOf(productId);
        if(productIndexToRemove > -1) {
          wishlistProducts.splice(productIndexToRemove, 1);
        }
      
		localStorage.setItem('theme:wishlist-products', JSON.stringify(wishlistProducts));

	} else {
      wishlistProducts.push(productId);
      localStorage.setItem('theme:wishlist-products', JSON.stringify(wishlistProducts));
		wishlistElement.classList.add('added-wishlist');
	}

  if(document.querySelector("wishlist-products")){
    document.querySelector("wishlist-products").loadWishlistProducts();
  }

  handleWishlist();
}

window.handleWishlist = () => {
  document.querySelectorAll('#CartDrawer modal-opener').forEach(el => el.remove());
  let wishlistProducts = localStorage.getItem('theme:wishlist-products') || '[]';

    var wishlistButtons = document.querySelectorAll(`.add-to-wishlist[data-product-id]`);
   wishlistButtons.forEach(wishlistButton => {
          
          if(wishlistButton) {
          wishlistButton.classList.remove('added-wishlist');
        } 
        });
    wishlistProducts = JSON.parse(wishlistProducts);
	if(wishlistProducts.length) {
      wishlistProducts.forEach(wishlistProduct => {
        var wishlistElements = document.querySelectorAll(`.add-to-wishlist[data-product-id="${wishlistProduct}"]`);

        wishlistElements.forEach(wishlistElement => {
          
        
          if(wishlistElement) {
          wishlistElement.classList.add('added-wishlist');
        } 
        });
        
      });
      document.querySelector(".header_wishlist_icon")?.classList.add("has-wishlist-items");
	} else {
      document.querySelector(".header_wishlist_icon")?.classList.remove("has-wishlist-items");
    }
};
document.addEventListener("DOMContentLoaded", function() {
handleWishlist();
});

// Automatically remove a product from the wishlist once it's been added to the bag
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    const productId = event && event.cartData ? parseInt(event.cartData.product_id, 10) : null;
    if (!productId) return;

    let wishlistProducts = JSON.parse(localStorage.getItem('theme:wishlist-products') || '[]');
    const productIndex = wishlistProducts.indexOf(productId);
    if (productIndex === -1) return;

    wishlistProducts.splice(productIndex, 1);
    localStorage.setItem('theme:wishlist-products', JSON.stringify(wishlistProducts));

    if (document.querySelector('wishlist-products')) {
      document.querySelector('wishlist-products').loadWishlistProducts();
    }

    handleWishlist();
  });
}
/** Wishlist **/

/** Countdown timer **/
window.initCountdownTimer = ($date, $timerContainer) => {

  // Set the date we're counting down to
  let countdown_date = new Date($date).getTime();

 // setTimeout(function(){
 // $timerContainer.closest(".countdown-timer-content-wrapper").classList.remove("hide");
  // $timerContainer.closest(".countdown-timer-content-wrapper").classList.remove("hide-timer");
 // }, 1000);
  // Update the count down every 1 second
  var countdown_timer_interval = setInterval(function() {

    // Get today's date and time
    let now = new Date().getTime();

    // Find the distance between now and the count down date
    let distance = countdown_date - now;

    // Time calculations for days, hours, minutes and seconds
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Output the result in an element with id="countdown-timer-container"
    const daysSpan = $timerContainer.querySelector('.days');
    const hoursSpan = $timerContainer.querySelector('.hours');
    const minutesSpan = $timerContainer.querySelector('.minutes');
    const secondsSpan = $timerContainer.querySelector('.seconds');

    function padWithZero(number) {
    return number.toString().padStart(2, '0');
    }
    
    if(daysSpan){
      daysSpan.innerHTML = padWithZero(days);
    }
    if(hoursSpan){
      hoursSpan.innerHTML = padWithZero(hours);
    } 
    if(minutesSpan){
      minutesSpan.innerHTML = padWithZero(minutes);
    }
    if(secondsSpan){
      secondsSpan.innerHTML = padWithZero(seconds);
    }
   

    $timerContainer.closest(".countdown-timer-content-wrapper").classList.remove("hide-timer");
    // If the count down is over, write some text or do some other action
    if (distance < 0) {
      clearInterval(countdown_timer_interval);

      if(document.querySelector(".buy-buttons-wrapper-and-wishlist")) {
        document.querySelector(".buy-buttons-wrapper-and-wishlist").classList.remove("timer-enabled");
      }

      if(document.querySelector(".timer-element")) {
        document.querySelector(".timer-element").classList.remove("hidden");
      }
      
      //$timerContainer.style.display = "none";

    }
  }, 1000);
};
/** Countdown timer **/

function modelImageSwitcher($this) {
  
    document.querySelectorAll(".image-switcher-item")?.forEach(switcherItem => switcherItem.classList.remove("switcher-active"));
    $this.classList.add("switcher-active")
    document.querySelectorAll(".product-alternate-image.has-product-image")?.forEach(alternateImage => alternateImage.classList.add("hidden"));
    document.querySelectorAll(`.product-alternate-image.has-product-image.${$this.dataset.switch}`)?.forEach(alternateImage => alternateImage.classList.remove("hidden"));
  
}
function handleFacetFilterTab($this) {
  document.querySelectorAll(".facet-filters-headings > div")?.forEach(div => div.classList.remove("active-heading"));
  document.querySelectorAll(".facet-filter-values > div")?.forEach(div => div.removeAttribute("open"));
  document.querySelector(`[id="${$this.dataset.id}"]`)?.setAttribute("open", true);
  $this.classList.add("active-heading");
}
function handleFacetFilterAccordion($this) {
  $this.classList.add("current");
  document.querySelector(`[id="${$this.dataset.id}"]`).classList.add("current");
  document.querySelectorAll(".facet-filters-accordion-wrapper > .facet-filter-label-wrapper:not(.current)")?.forEach(div => div.classList.remove("active-heading"));
  document.querySelectorAll('.facet-filters-accordion-wrapper > .mobile-facets__details:not(.current)')?.forEach(div => div.removeAttribute("open"));
  document.querySelector(`[id="${$this.dataset.id}"]`)?.toggleAttribute("open");
  $this.classList.toggle("active-heading");
   $this.classList.remove("current");
  document.querySelector(`[id="${$this.dataset.id}"]`).classList.remove("current");
}
function sizeMetricChange($this) {

  let $sizeChartTable = $this.closest(".size-chart-table-wrapper");

  if($this.classList.contains("size-chart-metric")) {

    document.querySelectorAll(".size-metric-value").forEach(metric_value => metric_value.style.display = "none");
    document.querySelectorAll(`.size-metric-value.value-in-${$this.value}`).forEach(metric_value => metric_value.style.display = "block");
    
  } else {

       if($this.checked){

     $sizeChartTable.querySelectorAll(".value-in-cm").forEach(valueInCm => valueInCm.style.display = "block");
     $sizeChartTable.querySelectorAll(".value-in-in").forEach(valueInIn => valueInIn.style.display = "none");
   } else {
     $sizeChartTable.querySelectorAll(".value-in-cm").forEach(valueInCm => valueInCm.style.display = "none");
     $sizeChartTable.querySelectorAll(".value-in-in").forEach(valueInIn => valueInIn.style.display = "block");
   }
    
  }
}

function toggleSubmenu($this, $event) {
  $event.preventDefault();
  $this.classList.toggle("active-menu-link");
   $this.closest("li").classList.toggle("active-menu");
   const body = document.getElementById("mobNavDrawer");
    if (body) {
      body.classList.add("second_label_menu_active"); 
    }
}
function toggleTabMenu($this, $event) {
  $event.preventDefault();

  const allMenuItems = document.querySelectorAll("li.has-children.first-label-menu");
  allMenuItems.forEach((item) => {
    item.classList.remove("active-menu");
  });
  const allTabLinks = document.querySelectorAll(".tab_menu_wrapper .mob-parent-button-mobile-drawer");
  allTabLinks.forEach((link) => {
    link.classList.remove("active-menu-link");
  });
   $this.classList.add("active-menu-link");
   $this.closest("li").classList.add("active-menu");
   const body = document.getElementById("mobNavDrawer");
    if (body) {
      body.classList.add("second_label_menu_active"); 
    }
}
/* Cart Drawer/wishlist Toggle */
function toggleTab(activeTarget, elem, activeElem, newTarget) {
  document.getElementById(activeTarget).style.display = 'none';
  document.getElementById(newTarget).style.display = 'block';
  elem.classList.add('tab-toggle-active');
  document.getElementById(activeElem).classList.remove('tab-toggle-active');
}

function toggleSecondLabelClass() {
    // Remove classes from the drawer
    const mobNavDrawer = document.getElementById("mobNavDrawer");
    if (mobNavDrawer) {
      mobNavDrawer.classList.remove("second_label_menu_active");
    }

    // Remove 'active-menu' class from the closest parent with class 'has-children'
    const button = event.currentTarget;
    const closestHasChildren = button.closest(".has-children");
    if (closestHasChildren) {
      closestHasChildren.classList.remove("active-menu");
    }
}

function dispatchCloseDrawerEvents() {
  document.querySelectorAll('.nav__drawer_close_button').forEach(btn =>
    btn.addEventListener('click', () => {
      const closeBtn = document.getElementById('mobNavDrawerClose');
      closeBtn?.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      document.getElementById("mobNavDrawer")?.classList.remove("second_label_menu_active");
      document.querySelector(".has-children.first-label-menu.active-menu")?.classList.remove("active-menu");
    })
  );
}

function addCart(currentElement) {
	if (!currentElement) return;
	currentElement.classList.add('loading');
	currentElement.querySelector('.loading-overlay__spinner').classList.remove('hidden');
	const config = fetchConfig('javascript');
	config.headers['X-Requested-With'] = 'XMLHttpRequest';
	delete config.headers['Content-Type'];
	const formData = new FormData();
	formData.append('id', currentElement.dataset.variantId);
	formData.append('quantity', 1);
	const cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
	if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
		cartUI.getSectionsToRender().forEach((section) => {
			formData.append('sections[]', section.id);
		});
		formData.append('sections_url', window.location.pathname);
	}
	config.body = formData;
	fetch(`${routes.cart_add_url}`, config)
		.then(res => res.json())
		.then(response => {
			if (response.status) {
				console.error('Add to cart error:', response);
				return;
			}
			publish(PUB_SUB_EVENTS.cartUpdate, {
				source: 'instant-search-add',
				productVariantId: formData.get('id'),
				cartData: response,
			});
			if (cartUI && typeof cartUI.renderContents === 'function') {
				cartUI.renderContents(response);
			}
		})
		.catch(err => console.error(err))
		.finally(() => {
			if (cartUI && cartUI.classList.contains('is-empty')) cartUI.classList.remove('is-empty');
			setTimeout(() => {
				currentElement.classList.remove('loading');
				currentElement.querySelector('.loading-overlay__spinner').classList.add('hidden');
				document.querySelector('.usf-popup').classList.add('usf-hide');
			});
		});
}
if (!window.__boaCardSwatchPreviewInit) {
  window.__boaCardSwatchPreviewInit = true;
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-card-swatch-link]');
    if (!swatch) return;
    e.preventDefault();

    var card = swatch.closest('.card-product');
    if (!card) return;

        var img = card.querySelector('.product-card-default-image img') || card.querySelector('.card-product--single-image-wrapper img');
    var revealImg = card.querySelector('.product-card-reveal-image img');
    var newSrc = swatch.dataset.swatchImage;
    if (img && newSrc) {
      img.removeAttribute('srcset');
      img.src = newSrc;
    }
    if (revealImg && newSrc) {
      revealImg.removeAttribute('srcset');
      revealImg.src = newSrc;
    }

    var badgesHtml = swatch.dataset.swatchBadges;
    var badgesContainer = card.querySelector('.card-product--badges');
    if (badgesContainer && badgesHtml !== undefined) {
      badgesContainer.innerHTML = badgesHtml;
    }

    var newUrl = swatch.dataset.swatchUrl;
    if (newUrl) {
      var viewLink = card.querySelector('.card-media > a') || card.querySelector('a[href]');
      if (viewLink) {
        var oldHref = viewLink.getAttribute('href');
        card.querySelectorAll('a[href="' + oldHref + '"]').forEach(function (a) {
          a.setAttribute('href', newUrl);
        });
      }
    }

    var list = swatch.closest('.cross-link-swatch-list');
    if (list) {
      list.querySelectorAll('.selected').forEach(function (el) {
        el.classList.remove('selected');
      });
    }
    swatch.classList.add('selected');
  });
}
if (!window.__boaCompleteLookHoverInit) {
  window.__boaCompleteLookHoverInit = true;

  document.addEventListener('mouseover', function (e) {
    var item = e.target.closest('.boa-complete-look__item');
    if (!item) return;
    var block = item.closest('.boa-complete-look');
    if (!block) return;
    var titleEl = block.querySelector('.boa-complete-look__header-title');
    var priceEl = block.querySelector('.boa-complete-look__header-price');
    if (!titleEl) return;

    var itemTitleEl = item.querySelector('.card-product-title-h3');
    var itemPriceEl = item.querySelector('.price-item--sale') || item.querySelector('.price-item--regular');
    if (itemTitleEl) titleEl.textContent = itemTitleEl.textContent.trim();
    if (priceEl) priceEl.textContent = itemPriceEl ? itemPriceEl.textContent.trim() : '';
  });

  document.addEventListener('mouseout', function (e) {
    var item = e.target.closest('.boa-complete-look__item');
    if (!item) return;
    if (item.contains(e.relatedTarget)) return;
    var block = item.closest('.boa-complete-look');
    if (!block) return;
    var titleEl = block.querySelector('.boa-complete-look__header-title');
    var priceEl = block.querySelector('.boa-complete-look__header-price');
    if (!titleEl) return;
    titleEl.textContent = titleEl.dataset.defaultText || titleEl.textContent;
    if (priceEl) priceEl.textContent = '';
  });
}
if (!window.__boaCompleteLookArrowsInit) {
  window.__boaCompleteLookArrowsInit = true;

  function updateArrows(block) {
    var grid = block.querySelector('.boa-complete-look__grid');
    var prevBtn = block.querySelector('.boa-complete-look__arrow--prev');
    var nextBtn = block.querySelector('.boa-complete-look__arrow--next');
    if (!grid) return;
    var maxScroll = grid.scrollWidth - grid.clientWidth;
    if (prevBtn) prevBtn.classList.toggle('is-hidden', grid.scrollLeft <= 2);
    if (nextBtn) nextBtn.classList.toggle('is-hidden', maxScroll <= 2 || grid.scrollLeft >= maxScroll - 2);
  }

  function refreshAll() {
    document.querySelectorAll('.boa-complete-look').forEach(updateArrows);
  }

  refreshAll();
  window.addEventListener('resize', refreshAll);

  document.addEventListener('scroll', function (e) {
    if (!e.target.classList || !e.target.classList.contains('boa-complete-look__grid')) return;
    var block = e.target.closest('.boa-complete-look');
    if (block) updateArrows(block);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.boa-complete-look__arrow');
    if (!btn) return;
    var block = btn.closest('.boa-complete-look');
    var grid = block && block.querySelector('.boa-complete-look__grid');
    if (!grid) return;
    var scrollAmount = grid.clientWidth * 0.9;
    grid.scrollBy({
      left: btn.classList.contains('boa-complete-look__arrow--prev') ? -scrollAmount : scrollAmount,
      behavior: 'smooth'
    });
  });

  var completeLookObserver = new MutationObserver(function () {
    refreshAll();
  });
  completeLookObserver.observe(document.body, { childList: true, subtree: true });
}
if (!window.__boaAppDownloadInit) {
  window.__boaAppDownloadInit = true;
  document.addEventListener('click', function (e) {
    var link = e.target.closest('#boaAppDownloadLink');
    if (!link) return;
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    var iosUrl = 'https://apps.apple.com/gb/app/because-of-alice/id6499224489';
    var androidUrl = 'https://play.google.com/store/apps/details?id=com.vennapps.becauseofalice';
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      e.preventDefault();
      window.location.href = iosUrl;
    } else if (/android/i.test(ua)) {
      e.preventDefault();
      window.location.href = androidUrl;
    }
  });
}